import LoginComponent from '../components/Auth/Login';

const Login = () => {
  return <LoginComponent />;
};

export default Login;